export default "__VITE_ASSET__AgjfkPjN__"